module.exports = __webpack_public_path__ + "images/e72f0c401000af66d8ea0125d0a32554-Roboto-BoldItalic.svg";